import { render, staticRenderFns } from "./TextAreaQuestion.vue?vue&type=template&id=02486034"
import script from "./TextAreaQuestion.vue?vue&type=script&lang=js"
export * from "./TextAreaQuestion.vue?vue&type=script&lang=js"
import style0 from "./TextAreaQuestion.vue?vue&type=style&index=0&id=02486034&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports